module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./index.js"));
	}, "HotSaleListView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=HotSaleListView!./src/pages/PunchClock/Bean/RecommendBeanList/index.js
// module id = 1788
// module chunks = 418